import React from 'react';

// EL SEMÁFORO (punto 32 del 07-08). Cinco estados, por celda y no por fila: así se
// distingue quién va regular de quién va mal, y en qué. Los estados los decide el backend
// contra el plazo del plan de cada cliente; aquí solo se pintan.
//
// `info` no es un estado peor ni mejor: es "esta casilla no cuenta para este cliente" (su
// plan no lleva chat, o no hay dato). Por eso va en gris apagado y no en un color de aviso.
// Vivía en la lista vieja de Clientes (`AdminDashboard.jsx`); desde el 19-10 lo pinta el
// desplegable de cada cliente en la pantalla Clientes.
const SEMAFORO = {
    ok:           'text-emerald-400',
    regular:      'text-amber-400',
    regular_malo: 'text-orange-400 font-bold',
    malo:         'text-red-400 font-bold',
    info:         'text-white/25',
};
// Sobre fondo blanco (la pantalla Clientes desde el 20-10): los mismos estados, más oscuros.
const SEMAFORO_CLARO = {
    ok:           'text-[#15803D]',
    regular:      'text-[#B45309]',
    regular_malo: 'text-[#C2410C] font-bold',
    malo:         'text-[#B91C1C] font-bold',
    info:         'text-[#8A867E]',
};

const CeldaSemaforo = ({ celda, testId, tamano = 'text-sm', claro = false }) => {
    const tonos = claro ? SEMAFORO_CLARO : SEMAFORO;
    if (!celda) return <span className={`${tonos.info} ${tamano}`}>-</span>;
    return (
        <span className={`${tamano} tabular-nums ${tonos[celda.estado] || (claro ? 'text-[#57544E]' : 'text-white/60')}`}
            title={celda.detalle || undefined} data-testid={testId} data-estado={celda.estado}>
            {celda.texto ?? '-'}
        </span>
    );
};

export default CeldaSemaforo;
